export const APP_BAR_HEIGHT: number = 70;
